export default __webpack_public_path__ + "static/money-bag-9795ab5ab9882bc6d833b07912940b50.svg";